import React from "react";
import { NavLink } from "react-router-dom";

const ItineryContent = ({
  smallTitle,
  heading,
  description,
  btnText,
  getintouch,
  getAlt,
  itiContentImg,
  align = "left",
  query
}) => {
  const content = <div
    className="col-sm-6 col-md-8 content">
    <div className="greentext">
      <span></span> {smallTitle}
    </div>
    <h2> {heading} </h2>
    <div className="desc_para" dangerouslySetInnerHTML={{ __html: description }}>
    </div>
    <NavLink className={"getintouchWrapper"} to={`/contact${`?query=${query}`}`}>
      <div className="getintouch">
        {btnText}
        <span className="getintouchLink"> </span>
      </div>
    </NavLink>
  </div>

  return (
    <>
      <div className="row contentimage list">
        {align === "left"? content : null} 
        <div className="col-sm-6 col-md-4">
          <img className="whyimg" src={itiContentImg} alt="why_img_1" />
        </div>
        {align === "right" ? content : null}
      </div>
    </>
  );
};

export default ItineryContent;
